























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BInputGroup, BInputGroupText, BModal, BButton } from 'bootstrap-vue';
import { Report, ReportElement } from '@/models/Report';
import { Form } from '@/models/Form';
import ModalRestart from '@/components/modals/ModalRestart.vue';
import ModalSendReport from '@/components/modals/ModalSendReport.vue';
import { mapGetters } from 'vuex';
import { hexToRgb, Pdf } from '../models/Pdf';

@Component({
    name: 'BaseReport',
    components: {
        'b-modal': BModal,
        'b-button': BButton,
        'modal-restart': ModalRestart,
        'modal-send-report': ModalSendReport,
    },
    computed: mapGetters(['report', 'form', 'accessCode']),
})
export default class BaseReport extends Vue {
    clipboard: string = '';
    form!: Form;
    report!: Report;
    accessCode!: string;

    copyUrl() {
        if (this.report) {
            const url = process.env.VUE_APP_CLIENT_URL + '/report/' + this.form.id + '/' + this.accessCode;
            const input = document.createElement('input');

            input.setAttribute('id', 'clippy');
            input.setAttribute('type', 'text');
            input.setAttribute('value', url);
            input.setAttribute('style', 'display: block; opacity: 0;');

            (document as any).getElementById('app').appendChild(input);
            (document as any).getElementById('clippy').select();
            (document as any).execCommand('copy');
            (document as any).getElementById('clippy').remove();

            this.clipboard = url;
        }
    }

    private generatePdf() {
        const pdf = new Pdf();
        const bgColor = hexToRgb(this.form.background);

        pdf.setHeading(this.form.title, 22, bgColor);
        pdf.setHeading(this.form.description, 16, hexToRgb(this.form.buttons));

        Object.values(this.report.report).forEach((reportElement: ReportElement) => {
            const type = reportElement.type;

            switch (type) {
                case 'score':
                    if (reportElement.params.score) {
                        pdf.setScorePoints(reportElement.params.score, 12, { r: 0, g: 0, b: 0 });
                        pdf.setScoreProgressBar(reportElement.params.score, bgColor);
                    }
                    break;
                case 'html':
                    if (reportElement.params.body) {
                        pdf.parseHTML(reportElement.params.body, 12);
                    }
                    break;
                case 'button':
                    if (reportElement.params.color) {
                        pdf.setButton(reportElement.params, 12, hexToRgb(reportElement.params.color));
                    }
                    break;
                default:
                    break;
            }
        });
        pdf.save(this.form.title);
    }
}
